import axiosInstance from './axiosCreator';
import { store } from '../store/store';
import { todaySessionUpdated } from '../slices/todaySession/todaySessionSlice';

export const updateStudySession = async ({
  id,
  date,
  isComplete,
  phase,
  isStarted,
  isUsingFlashcards,
  isUsingQbank,
  activeBlockId,
  vignetteCount,
  vignetteCorrectCount,
  vignetteIncorrectCount,
  vignetteOmittedCount,
  flashcardCount,
  completedFlashcardCount,
  isSnoozed,
  isDemo,
  hasSeenPriorities,
  isFirstSession,
}: {
  id: string;
  date?: string;
  isComplete?: boolean;
  phase?: string;
  isStarted?: boolean;
  isUsingFlashcards?: boolean;
  isUsingQbank?: boolean;
  activeBlockId?: string;
  vignetteCount?: number;
  vignetteCorrectCount?: number;
  vignetteIncorrectCount?: number;
  vignetteOmittedCount?: number;
  flashcardCount?: number;
  completedFlashcardCount?: number;
  isSnoozed?: boolean;
  isDemo?: boolean;
  hasSeenPriorities?: boolean;
  isFirstSession?: boolean;
}) => {
  try {
    const response = await axiosInstance.put(`/studySession/${id}`, {
      ...(date !== undefined && { date }),
      ...(isComplete !== undefined && { isComplete }),
      ...(phase !== undefined && { phase }),
      ...(isStarted !== undefined && { isStarted }),
      ...(isUsingFlashcards !== undefined && { isUsingFlashcards }),
      ...(isUsingQbank !== undefined && { isUsingQbank }),
      ...(activeBlockId !== undefined && { activeBlockId }),
      ...(vignetteCount !== undefined && { vignetteCount }),
      ...(vignetteCorrectCount !== undefined && { vignetteCorrectCount }),
      ...(vignetteIncorrectCount !== undefined && { vignetteIncorrectCount }),
      ...(vignetteOmittedCount !== undefined && { vignetteOmittedCount }),
      ...(flashcardCount !== undefined && { flashcardCount }),
      ...(completedFlashcardCount !== undefined && { completedFlashcardCount }),
      ...(isSnoozed !== undefined && { isSnoozed }),
      ...(isDemo !== undefined && { isDemo }),
      ...(hasSeenPriorities !== undefined && { hasSeenPriorities }),
      ...(isFirstSession !== undefined && { isFirstSession }),
    });
    store.dispatch(todaySessionUpdated(response.data.data));
    return response.data.data;
  } catch (error) {
    console.error(error);
  }
};

// Get flashcardResponses for a studySession
export const fetchFlashcardResponses = async (sessionId: string) => {
  try {
    const response = await axiosInstance.get(
      `/studySession/${sessionId}/flashcardResponses`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// Get all study sessions for current user
export const fetchStudySessions = async () => {
  try {
    const response = await axiosInstance.get('/studySession');
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// Get the first session of an exam for current user
export const fetchFirstStudySession = async (examId: string) => {
  try {
    const response = await axiosInstance.get(
      `/studySession/${examId}/firstExamSession`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// Get all sessions of an exam for current user
export const fetchAllExamSessions = async (examId: string) => {
  try {
    const response = await axiosInstance.get(
      `/studySession/${examId}/sessions`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// Get all sessions of an exam with blocks for current user
export const fetchAllExamSessionsAndBlocks = async (examId: string) => {
  try {
    const response = await axiosInstance.get(
      `/studySession/${examId}/sessionAndBlocks`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// Get all study sessions for current user
export const fetchStudyStreak = async () => {
  try {
    const response = await axiosInstance.get(`/studySession/streak`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// Get all articles for a study session
export const getTodayArticles = async (studySessionId: string) => {
  const response = await axiosInstance.get(
    `/studySession/${studySessionId}/articles`
  );
  return response.data;
};
